import { Grid } from "@mui/material";
import { GraphicCore } from "./GraphicPieCore/index";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";

export const GraphicPieIndex = () => {
  const { valuesBalancePiesADM, valuesBalancePiesOperadora, valuesBalancePiesModalidade } = useMetricsContext();

  return (
    <>
      <Grid item md={4} xs={12}>
        <GraphicCore title="Operadora" data={valuesBalancePiesOperadora} />
      </Grid>
      <Grid item md={4} xs={12}>
        <GraphicCore title="Administradora" data={valuesBalancePiesADM} />
      </Grid>
      <Grid item md={4} xs={12}>
        <GraphicCore title="Modalidade" data={valuesBalancePiesModalidade} />
      </Grid>
    </>
  );
};
